import { render, staticRenderFns } from "./_base-content-footer.vue?vue&type=template&id=4e77d951&"
import script from "./_base-content-footer.vue?vue&type=script&lang=js&"
export * from "./_base-content-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports